module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/pricing-booking/shared-component/shared-component.component.css
// module id = ./src/app/component/pricing-booking/shared-component/shared-component.component.css
// module chunks = main